import {AnyAction} from "redux";
import {INCREMENT_YEAR, SET_SEASON, SET_YEAR, SHOW_NEXT_OUTAGE_QUESTION, SHOW_QUESTION} from "../actions/action";
import * as _ from 'lodash';
import {createSelector} from "reselect";
import {getSeasonsData, getYearsData, ISeason, IYear} from "../../data/data";


//  define selectors

export const getYearIndex = state => state.year;


/**
 * get the data object for a year
 */
export const getYearData = createSelector(

    [getYearIndex],

    (season_id: string) : IYear =>
    {
        const year: IYear[] = getYearsData();

        return _.get(year, season_id);
    }
);

/**
 * get the data object for a year
 */
export const getPreviousYearData = createSelector(

    [getYearIndex],

    (season_id: number) : IYear =>
    {
        const year: IYear[] = getYearsData();

        return _.get(year, season_id - 1);
    }
);

//
//
// /**
//  * get the index of a season
//  */
// export const getSeasonIndex = createSelector(
//
//     [getSeasonID],
//
//     (season_id: string) : number =>
//     {
//         const seasons: ISeason[] = getSeasonsData();
//
//         return _.findIndex(seasons, ['id', season_id])
//     }
// );



/**
 * reducer: set the current year
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function year(state: number = 0, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_YEAR:
        {
            const {payload} = action;
            const {year} = payload;

            return year;
        }

        case INCREMENT_YEAR:
        {
            return state + 1;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/year.ts